<template>
  <v-container>
    <v-layout
      row
      justify-space-between
    >
      <v-flex xs3>
        <v-avatar
          size="75px"
          tile>
          <img
            src="@/assets/logo.png"
            alt="Baxter State Park"
          >
        </v-avatar>
      </v-flex>
      <v-flex
        class="text-xs-center"
        xs6
      >
        <h1>Reservation Confirmation</h1>
        <p>This Confirmation Must Be Presented to the Ranger Upon Arrival</p>
      </v-flex>
      <v-flex
        class="text-xs-right"
        xs3
      >
        Baxter State Park<br>
        64 Balsam Drive<br>
        Millinocket, ME 04462<br>
        (207) 723-5140<br>
      </v-flex>
    </v-layout>
    <p v-html="settings.textReservationTop"/>
    <v-layout
      row
      justify-space-between
      class="mb-4"
    >
      <v-flex xs4>
        {{ person.lastName }}, {{ person.firstName }}<br>
        {{ person.address1 }}<br>
        <template v-if="person.address2">
          {{ person.address2 }}<br>
        </template>
        {{ person.city }}, {{ person.state }} {{ person.zip }}<br>
        {{ person.country }}<br>
      </v-flex>
      <v-flex>
        Itinerary ID: {{ itinerary.itineraryID }}<br>
        Camper ID: {{ person.personID }}<br>
        Printed: {{ new Date().toLocaleDateString() }}<br>
        Gate Passes: {{ itinerary.gatePasses }}
      </v-flex>
      <v-flex
        xs4
        class="font-weight-bold"
        v-html="settings.textReservationBold"
      />
    </v-layout>
    <div
      v-for="campsiteBooking in sortedGroupedCampsiteBookings"
      :key="campsiteBooking.campsiteBookingID"
    >
      <v-layout
        row
        justify-space-between
        class="py-2"
      >
        <v-flex
          xs1
          class="text-xs-center"
        >
          {{ campsiteBooking.startDate }}<br>
          to<br>
          {{ campsiteBooking.endDate }}
        </v-flex>
        <v-flex xs3>
          {{ campsiteBooking.campgroundName }}: {{ campsiteBooking.campsiteNumber }} {{ campsiteBooking.campsiteName }}<br>
          {{ campsiteBooking.campsiteTypeWord }}
          <CampsiteIcons :campsite="campsiteBooking"/>
        </v-flex>
        <v-flex xs5>
          <p v-if="campsiteBooking.commercialPermitID">CUPS #: {{ campsiteBooking.commercialPermitID }} </p>
          {{ campsiteBooking.nights }} Nights.<br>
          {{ campsiteBooking.campsiteDetails }}
        </v-flex>
        <v-flex xs2>
          Capacity: {{ campsiteBooking.campsiteCapacity }}<br>
          Adult: {{ campsiteBooking.adult }}<br>
          Junior: {{ campsiteBooking.junior }}<br>
          Child: {{ campsiteBooking.child }}
        </v-flex>
      </v-layout>
      <v-divider/>
    </div>
    <v-layout row>
      <v-flex
        xs6
      >
        <VueQrcode
          :value="qrData"
          :options="{ size: 300 }"
        />
      </v-flex>
      <v-flex>
        <v-card class="elevation-4 my-4 pa-4">
          <v-layout row>
            <v-flex>
              <h3>Notes</h3>
            </v-flex>
            <v-flex>
              {{ itinerary.note }}
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment-timezone'
import VueQrcode from '@xkeshi/vue-qrcode'
export default {
  components: {
    VueQrcode
  },
  computed: {
    ...mapGetters({
      itinerary: 'itineraries/itinerary',
      person: 'person/person',
      searchResults: 'person/searchResults'
    }),
    qrData () {
      return JSON.stringify({
        type: 'itinerary',
        ID: this.$route.params.id,
        personID: this.person.personID
      })
    },
    sortedCampsiteBookings () {
      let bookings = this.itinerary?.campsiteBookings
      if (bookings) {
        return bookings.sort((first, second) => {
          if (first.campsiteID < second.campsiteID) {
            return -1
          }
          if (first.campsiteID > second.campsiteID) {
            return 1
          }
          return 0
        })
      }
      return []
    },
    groupedCampsiteBookings () {
      let split = (newBooking, lastBooking) => {
        return (newBooking.campsiteID !== lastBooking.campsiteID ||
                newBooking.adult !== lastBooking.adult ||
                newBooking.junior !== lastBooking.junior ||
                newBooking.child !== lastBooking.child ||
                moment(newBooking.date).diff(moment(lastBooking.endDate), 'days') !== 1
        )
      }
      if (this.sortedCampsiteBookings) {
        return this.sortedCampsiteBookings.reduce((groups, newBooking) => {
          if (!groups.length) { // first entry
            groups.push({
              ...newBooking,
              startDate: newBooking.date,
              endDate: newBooking.date,
              nights: 1
            })
          } else {
            const lastBooking = groups[groups.length - 1]
            if (split(newBooking, lastBooking)) { // same site or consecutive
              groups.push({
                ...newBooking,
                startDate: newBooking.date,
                endDate: newBooking.date,
                nights: 1
              })
            } else {
              lastBooking.endDate = newBooking.date
              lastBooking.nights += 1
            }
          }

          return groups
        }, [])
      }
      return []
    },
    sortedGroupedCampsiteBookings () {
      let bookings = this.groupedCampsiteBookings
      if (bookings) {
        return bookings.sort((first, second) => {
          if (first.startDate < second.startDate) {
            return -1
          }
          if (first.startDate > second.startDate) {
            return 1
          }
          return 0
        })
      }
      return []
    }

  },
  mounted () {
    let itinerary = {
      itineraryID: this.$route.params.id
    }
    this.getItinerary(itinerary).then(() => {
      this.getCampsiteBookings(itinerary).then(() => {
        // window.print()
        // this.$router.go(-1)
      })
    })
  },
  methods: {
    ...mapActions({
      getItinerary: 'itineraries/getItinerary',
      getCampsiteBookings: 'itineraries/getCampsiteBookings',
      searchPeople: 'person/searchPeople',
      setProxyPerson: 'person/setProxyPerson'
    })
  }
}
</script>
